export default __webpack_public_path__ + "static/media/budget_calendar.c98f9b6c.png";